import React, { useContext, useEffect } from "react";
import classnames from "classnames";
import { useSelector } from "react-redux";

import { Category } from "constants/events";
import MenuContext from "context/MenuContext";
import useDomainCountryCode from "hooks/useDomainCountryCode";
import { getCurrentDispensary } from "redux/selectors/dispensary";
import { dispensaryHref } from "utils/dispensaryUrls";

import CoinList from "components/CoinList";

const CategoryCarousel = ({
  className,
  filterable,
  parsedQuery,
  showNewCoinListExperience,
}: {
  className?: string;
  filterable?: boolean;
  parsedQuery?: string;
  showNewCoinListExperience?: boolean;
}) => {
  const { slug: dispensarySlug, retailType } =
    useSelector(getCurrentDispensary);
  const {
    selectors: { menuFilters },
    dispatch: { getMenuItems },
  } = useContext(MenuContext);

  // This is to keep the category coins data current with the menuContext data.
  // Ticket to unify the data sources between filters and results. https://leafly.atlassian.net/browse/SHH-545
  useEffect(() => {
    getMenuItems();
  }, [parsedQuery]);

  const countryCode = useDomainCountryCode();

  const categories = menuFilters
    ?.find((option) => option.name === "product_category")
    ?.values?.map((value) => value.value);

  if (!categories || !categories.length) {
    return null;
  }

  const hrefLink = dispensaryHref({
    additionalPath: "/menu",
    countryCode,
    retailType,
    slug: dispensarySlug,
  });

  return (
    <div data-testid="category-carousel" className={classnames(className)}>
      <h2
        className="mb-lg heading--m font-extrabold"
        data-testid="category-carousel-header"
      >
        Shop by category
      </h2>
      <CoinList
        coins={categories}
        hrefLink={hrefLink}
        showNewCoinListExperience={showNewCoinListExperience}
        trackEvent={{
          eventCategory: Category.productCategoryCoinFilter,
        }}
        hrefProductCatQueryKey="product_category[]"
        filterable={filterable}
      />
    </div>
  );
};

export default CategoryCarousel;
